import { styled as StyledMui } from "@mui/system";
import { Box, Toolbar, Typography } from "@mui/material";
import HeaderBgImage from "../../assests/images/header_bg.png";
import { ReactComponent as BniLogo } from "../../assests/icons/connect_logo_white.svg";

export const HeaderContainerBg = StyledMui(Box)(({isHeaderShrink}) => ({
  backgroundImage: `url(${HeaderBgImage})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundColor: "#ffffff",
  height: String(isHeaderShrink) === "true"?"auto":"12.05vw",
  paddingTop: String(isHeaderShrink) === "true" && "0.5rem",
  paddingBottom: String(isHeaderShrink) === "true" && "0.5rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "@media only screen and (min-width: 1921px)": {
    height: "auto",
    paddingTop: String(isHeaderShrink) === "false" && "3rem",
    paddingBottom: String(isHeaderShrink) === "false" && "3rem",
  },
  "@media only screen and (max-width: 850px)": {
    height: "auto",
    paddingBottom: String(isHeaderShrink) === "false" && "3rem",
  },
  "@media only screen and (max-width: 650px)": {
    backgroundPosition: "inherit",
  },
}));

export const HeaderToolBar = StyledMui(Toolbar)(() => ({
  width: "89vw",
  gap: "6.1%",
  maxWidth: "1920px",
  "@media only screen and (min-width: 1921px)": {
    width:"90%",
  },
  "@media only screen and (max-width: 1065px)": {
    gap: "5%",
  },
  "@media only screen and (max-width: 850px)": {
    flexWrap: "wrap",
  },
}));

export const ConnectionsTextBox = StyledMui(Box)(() => ({
  flexBasis: "42%",
  alignSelf: "flex-center",
  "@media only screen and (max-width: 1180px)": {
    display: "none",
  },
}));

export const ConnectionsText = StyledMui(Typography)(({isHeaderShrink}) => ({
  fontSize: String(isHeaderShrink)==="true"?"3.2rem":"4rem",
  fontWeight: "700",
}));
export const ConnectionsIconBox = StyledMui(Box)(() => ({
  flexBasis: "9%",
  "@media only screen and (max-width: 1180px)": {
    display: "none",
  },
}));

export const HeaderUserDashboard = StyledMui(Box)(({ theme, isHeaderShrink }) => ({
  display: "flex",
  alignItems:"center",
  flexBasis: "17.7%",
  alignSelf:  "flex-start",
  marginTop: String(isHeaderShrink)==="true" ? "0.5rem" : "1rem",
  gap:"1.5rem",
  "@media only screen and (max-width: 850px)": {
    alignSelf: "flex-start",
    marginTop: "1rem",
  },
  "@media only screen and (max-width: 425px)": {
    flexBasis: "10%",
  }
}));

export const HeaderLegacyText = StyledMui(Typography)(() => ({
  marginTop: "1rem",
  fontSize: "1.4rem",
  textAlign: "left",
  width: "90%",
  lineBreak: "normal",
  cursor:"pointer",
  "@media only screen and (max-width: 1180px)": {
    fontSize: "1.1rem",
  }
}));

export const HeaderLegacyClickHere = StyledMui(Box)(() => ({
  fontSize: "1.6rem",
  fontWeight: "600",
  boxShadow: "0px 3px 0px -1px #ffffff",
  cursor: "pointer",
  marginRight:"0.5rem",
  "@media only screen and (max-width: 1180px)": {
    fontSize: "1.1rem",
  },
}));

export const LogoAndText = StyledMui(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  alignSelf: "flex-start",
  width:"100%"
  
}));

export const LogoTextAndNavigation = StyledMui(Box)(({isHeaderShrink}) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: String(isHeaderShrink) === "true"?"0rem":"1.5rem",
    flexBasis: "67%",
    "@media only screen and (max-width: 1180px)": {
      width: "100%",
      flexBasis: "100%",
      justifyContent: "center",
    },  
}));

export const LogoBox = StyledMui(Box)(() => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexBasis: "52%",
    alignSelf: "flex-start",
    "@media only screen and (max-width: 1180px)": {
    justifySelf: "center",
  },
}));

export const HeaderLogo = StyledMui(BniLogo)(({isHeaderShrink}) => ({
   cursor:"pointer",
   width: String(isHeaderShrink) === "true" && "100%",
   maxWidth: String(isHeaderShrink) === "true" && "20rem",
    "@media only screen and (max-width: 1180px)": {
    width: "100%",
    maxWidth: "20rem",
  },
}));


